import { Action } from 'redux'
import { isType } from 'ts-action'
import { IAvatarAnalysisErrorReducer } from '../../models/AvatarAnalysisError'
import { GetAvatarAnalysisErrors, AvatarAnalysisErrorsFetching } from './actions'

const initialState: IAvatarAnalysisErrorReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const avatarAnalysisErrorsReducer = (
  state = initialState,
  action: Action
): IAvatarAnalysisErrorReducer => {
  if (isType(action, GetAvatarAnalysisErrors)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, AvatarAnalysisErrorsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
